import { Link } from 'react-router-dom';
import './Breadcrumbs.css';

/**
 * Reusable SEO/GEO Breadcrumbs navigation component with Microdata & Schema.org markup.
 * @param {{
 *   items: Array<{ label: string, path?: string }>,
 *   className?: string
 * }} props
 */
const Breadcrumbs = ({ items = [], className = '' }) => {
  if (!Array.isArray(items) || items.length === 0) return null;

  const fullItems = [
    { label: 'Home', path: '/' },
    ...items
  ];

  return (
    <nav aria-label="Breadcrumb" className={`breadcrumbs-nav ${className}`.trim()}>
      <ol className="breadcrumbs-list" itemScope itemType="https://schema.org/BreadcrumbList">
        {fullItems.map((item, index) => {
          const isLast = index === fullItems.length - 1;
          return (
            <li
              key={`${item.label}-${index}`}
              className={`breadcrumbs-item ${isLast ? 'breadcrumbs-item-active' : ''}`}
              itemProp="itemListElement"
              itemScope
              itemType="https://schema.org/ListItem"
            >
              {!isLast && item.path ? (
                <Link to={item.path} className="breadcrumbs-link" itemProp="item">
                  <span itemProp="name">{item.label}</span>
                </Link>
              ) : (
                <span className="breadcrumbs-current" aria-current="page" itemProp="name">
                  {item.label}
                </span>
              )}
              <meta itemProp="position" content={String(index + 1)} />
              {!isLast && <span className="breadcrumbs-separator" aria-hidden="true">/</span>}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
